import getters from './getters'
import { actions as actions } from './actions'
import { mutations } from './mutations'

const state = {
  cart: {
    items: [],
    total: 0,
    min_expend: 3,
    services_total: 0
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/cart/index.js
// module id = null
// module chunks = 